import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import messages from './messages'

const BudgetCategoryChunk = lazy(() =>
  import('../containers/BudgetCategoryView').then(({ BudgetCategoryView }) => ({
    default: BudgetCategoryView,
  }))
)

export const BudgetCategoryPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.manageBudgetsTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.settingsPageTitle),
          link: url('SettingsPage'),
        },
        {
          name: intl.formatMessage(messages.manageBudgetsTitle),
        },
      ]}
    >
      <BudgetCategoryChunk />
    </Page>
  )
}
